<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ProductCategoriaColumnVue from 'Modules/contacard/produto/product/components/columns/ProductCategoriaColumn.vue';
import ProductTypeOperationColumnVue from 'Modules/contacard/produto/product/components/columns/ProductTypeOperationColumn.vue';
import ProductTypeValueColumnVue from 'Modules/contacard/produto/product/components/columns/ProductTypeValueColumn.vue';
import IntegradorRequest from 'Modules/contacard/produto/integrador/IntegradorRequest';

export default {
  name: 'ProdutoIntegradorList',
  extends: CrudListVue,
  data: () => ({
    requestClass: IntegradorRequest,
    hideEdit: true,
    headers: [
      {
        text: 'Código',
        value: 'produtoServico.id',
      },
      {
        text: 'Produto',
        value: 'produtoServico.nomProdutoServico',
      },
      {
        text: 'Categoria',
        value: 'produtoServico.produtoServicoCategoria',
        component: ProductCategoriaColumnVue,
      },
      {
        text: 'Tipo operação',
        value: 'produtoServico.tipoOperacao',
        component: ProductTypeOperationColumnVue,
      },
      {
        text: 'Tipo valor',
        value: 'produtoServico.tipoValorProduto',
        component: ProductTypeValueColumnVue,
      },
      {
        text: 'Valor produto',
        value: 'produtoServico.vlrProdutoServico',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor máximo',
        value: 'produtoServico.vlrVariavelMax',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor mínimo',
        value: 'produtoServico.vlrVariavelMin',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Código Gwcel',
        value: 'produtoServico.regionalMarca.codFilialGwcel',
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  computed: {
    getIntegradorId() {
      return this.$route.params.id;
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass
        .listIntegradorProduto(params, this.getIntegradorId);
    },
  },
};
</script>
